import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  constructor() { }
  private refreshMenu$ = new Subject<void>();
  refreshMenuObservable = this.refreshMenu$.asObservable();

  triggerRefreshMenu() {
    this.refreshMenu$.next();
  }

}
